import { render, staticRenderFns } from "./botaoSalvar.vue?vue&type=template&id=85a1611a&scoped=true&"
import script from "./botaoSalvar.vue?vue&type=script&lang=js&"
export * from "./botaoSalvar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a1611a",
  null
  
)

export default component.exports